export const STAGE_VALUES = {
  all: undefined,
  online: ['BEFORE_AUCTION', 'IN_AUCTION'],
  finished: ['FINISHED', 'REMOVED']
}
